import { createClient } from '@supabase/supabase-js';

// Versuche Umgebungsvariablen zu laden, sonst Platzhalter (damit App nicht crasht vor Konfiguration)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://dein-projekt.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'dein-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const BUCKET_NAME = 'moba-images';